import { render, staticRenderFns } from "./StandoffForm.vue?vue&type=template&id=8a99a160"
import script from "./StandoffForm.vue?vue&type=script&lang=js"
export * from "./StandoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports